import React, { Component } from 'react'
import Header from '../common/Header'
import Footer from '../common/Footer'
import Sliders from '../common/Sliders'

// import { ReactGoogleReviews } from "react-google-reviews";
// import "react-google-reviews/dist/index.css";


class AboutUs extends Component {

    state = {
        username: '',
        password: '',
        type: '',
        info: '',
        load: false,
        showMsg: false
    }

    componentDidMount() {
        // window.location.reload()
    }



    render() {
        const featurableWidgetId = "example"
        return (
            <>
                <body>
                    {<Header />}


                    <div class="homepage4-body">
                        <div class="vl-offcanvas" id="open">
                            <div class="vl-offcanvas-wrapper">
                                <div class="vl-offcanvas-header d-flex justify-content-between align-items-center mb-90">
                                    <div class="vl-offcanvas-logo">
                                        <a href="/"><img src="assets/img/logo/rehabLogo.png" alt="" /></a>
                                    </div>
                                    <div class="vl-offcanvas-close">
                                        <button class="vl-offcanvas-close-toggle"><i class="fa-solid fa-xmark"></i></button>
                                    </div>
                                </div>

                                <div class="vl-offcanvas-menu d-lg-none mb-40">
                                    <nav></nav>
                                </div>
                                <div class="space20"></div>

                                <div class="vl-offcanvas-info">

                                    <div class="btn-area1">

                                        <div class="btn-area1">
                                            <a href="https://wa.me/256755260852" target='_blank' class="vl-btn7"><svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                                                <g clip-path="url(#clip0_5832_90599)">
                                                    <path d="M4.32688 1.17695C4.79912 1.27456 5.1752 1.59185 5.40887 2.01104L6.15321 3.34641C6.42738 3.83825 6.65811 4.25215 6.80878 4.61195C6.96862 4.99364 7.06355 5.37002 7.02016 5.78615C6.97676 6.20229 6.80622 6.55099 6.57107 6.89148C6.3494 7.21245 6.03823 7.56985 5.66848 7.99454L4.57431 9.25135C4.37824 9.4766 4.2802 9.58919 4.27124 9.72994C4.26228 9.87069 4.34263 9.99094 4.50333 10.2314C5.87299 12.2806 7.71894 14.1272 9.76983 15.498C10.0103 15.6587 10.1305 15.739 10.2712 15.7301C10.412 15.7211 10.5247 15.6231 10.7498 15.427L12.0067 14.3328C12.4314 13.963 12.7888 13.6519 13.1098 13.4302C13.4502 13.195 13.799 13.0245 14.2151 12.9811C14.6312 12.9377 15.0077 13.0327 15.3893 13.1925C15.7491 13.3432 16.163 13.5739 16.6547 13.848L17.9902 14.5924C18.4094 14.8261 18.7267 15.2022 18.8243 15.6744C18.9229 16.1515 18.7775 16.6312 18.4562 17.0254C17.2904 18.4557 15.4227 19.3664 13.4633 18.9711C12.259 18.7282 11.0707 18.3234 9.63342 17.4992C6.74558 15.843 4.15636 13.2524 2.50212 10.3679C1.67786 8.9306 1.2731 7.74232 1.03015 6.53794C0.634898 4.57858 1.54559 2.71085 2.9759 1.5451C3.37009 1.22381 3.84971 1.07834 4.32688 1.17695Z" fill="white" />
                                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M11.3045 1.54C11.432 1.0978 11.894 0.842779 12.3362 0.970388C15.559 1.90041 18.0973 4.43862 19.0275 7.66132C19.155 8.1035 18.9 8.56545 18.4579 8.69304C18.0157 8.8207 17.5537 8.5657 17.4261 8.1235C16.6548 5.45101 14.5466 3.34295 11.874 2.57171C11.4319 2.4441 11.1769 1.98219 11.3045 1.54ZM10.793 5.47187C10.973 5.04825 11.4622 4.85066 11.8859 5.03055C13.2706 5.6186 14.3793 6.72725 14.9673 8.11199C15.1472 8.53562 14.9496 9.02487 14.526 9.20479C14.1024 9.38462 13.6131 9.18704 13.4332 8.76345C13.014 7.77614 12.2217 6.9839 11.2344 6.56463C10.8108 6.38474 10.6132 5.8955 10.793 5.47187Z" fill="white" />
                                                </g>
                                                <defs>
                                                    <clipPath id="clip0_5832_90599">
                                                        <rect width="20" height="20" fill="white" />
                                                    </clipPath>
                                                </defs>
                                            </svg> (0) 755 260852</a>
                                        </div>

                                        <br />

                                        <a href="https://wa.me/256755260852" class="vl-btn4">WhatsApp<span><svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22" fill="none">
                                            <path fill-rule="evenodd" clip-rule="evenodd" d="M11 0.25C5.06294 0.25 0.25 5.06294 0.25 11C0.25 16.9371 5.06294 21.75 11 21.75C16.9371 21.75 21.75 16.9371 21.75 11C21.75 5.06294 16.9371 0.25 11 0.25ZM10 7C9.5955 7 9.2309 7.24364 9.0761 7.61732C8.92134 7.99099 9.0069 8.42111 9.2929 8.70711L10.5858 10L7.29289 13.2929C6.90237 13.6834 6.90237 14.3166 7.29289 14.7071C7.68342 15.0976 8.31658 15.0976 8.70711 14.7071L12 11.4142L13.2929 12.7071C13.5789 12.9931 14.009 13.0787 14.3827 12.9239C14.7564 12.7691 15 12.4045 15 12V8C15 7.44772 14.5523 7 14 7H10Z" fill="white" />
                                        </svg></span></a>
                                    </div>


                                </div>

                                <div class="space20"></div>
                                <div class="vl-offcanvas-info">
                                    <h3 class="vl-offcanvas-sm-title">Contact Us</h3>
                                    <div class="space20"></div>
                                    <span><a href="#"> <i class="fa-solid fa-phone"></i> +256755260852</a></span>
                                    <span><a href="#"><i class="fa-regular fa-envelope"></i> info@ntindamedic.com</a></span>
                                    <span><a href="#"><i class="fa-solid fa-location-dot"></i> Ntinda Stretcher Road</a></span>
                                </div>
                                <div class="space20"></div>
                                <div class="vl-offcanvas-social">
                                    <h3 class="vl-offcanvas-sm-title">Follow Us</h3>
                                    <div class="space20"></div>
                                    <a href="#"><i class="fab fa-facebook-f"></i></a>
                                    <a href="#"><i class="fab fa-twitter"></i></a>
                                    <a href="#"><i class="fab fa-linkedin-in"></i></a>
                                    <a href="#"><i class="fab fa-instagram"></i></a>
                                </div>

                            </div>
                        </div>
                        <div class="vl-offcanvas-overlay"></div>
                    </div>

                    <div class="inner-header-section-area" style={{ backgroundImage: `url(assets/img/all-images/bg/bg9.png)`, backgroundPosition: 'center top', backgroundRepeat: 'no-repeat', backgroundSize: 'cover' }}>
                        {/* style="background-image: url(assets/img/all-images/bg/bg9.png); background-position: center; background-repeat: no-repeat; background-size: cover;" */}
                        <img src="assets/img/elements/elements28.png" alt="" class="elements28" />
                        <div class="container">
                            <div class="row align-items-center">
                                <div class="col-lg-12">
                                    <div class="hero-header">
                                        <h1 class="text-anime-style-1">About Us</h1>
                                        <div class="space28"></div>
                                        <a href="/" class="bradecrumb">Home <i class="fa-solid fa-angle-right"></i> About Us</a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>


                    <div class="about-inner-section-area sp1">
                        <div class="container">
                            <div class="row align-items-center">
                                <div class="col-lg-6">
                                    <div class="about-all-images">
                                        <div class="row">
                                            <div class="col-lg-6 col-md-6">
                                                <div class="images-content">
                                                    <img src="assets/img/elements/elements9.png" alt="" class="elements9" />
                                                    <div class="img1 image-anime ">
                                                        {/* <div class="img1 image-anime reveal"> */}
                                                        <img src="assets/img/all-images/about/about-img7.png" alt="" />
                                                    </div>
                                                    <div class="space24"></div>
                                                    <div class="experiance-box">
                                                        <h3><span class="counter">25</span>+</h3>
                                                        <p>Years Of Experience</p>
                                                    </div>
                                                </div>
                                            </div>

                                            <div class="col-lg-6 col-md-6">
                                                <div class="img1 image-anime">
                                                    {/* <div class="img1 image-anime reveal"> */}
                                                    <img src="assets/img/all-images/about/about-img20.png" alt="" />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-lg-6">
                                    <div class="heading4">
                                        <h5 class="vl-section-subtitle" data-aos-duration="800">Ntinda Medical Rehabilitation Center<span> | </span> About Us <svg xmlns="http://www.w3.org/2000/svg" width="13" height="8" viewBox="0 0 13 8" fill="none">
                                            <path d="M0.667969 4.00033H11.049M8.00137 7.33366L11.3346 4.00033L8.0013 0.666992" stroke="#02015A" stroke-width="1.5" />
                                        </svg>
                                        </h5>
                                        <div class="space20"></div>
                                        <h2 class="text-anime-style-3">Orthopedic Care That Goes Beyond Physical</h2>
                                        <div class="space18"></div>
                                        <p data-aos-duration="1000">We are community dedicated to enhancing your smile and overall health our team highly skilled professionals.</p>
                                        <div class="space28"></div>
                                        <div class="bg-progress" data-aos-duration="900">
                                            <div class="progress-bar">
                                                <label>Orthopedic services <span>98%</span></label>
                                                <div class="progress">
                                                    <div class="progress-inner" style={{ width: '98%' }}></div>
                                                </div>
                                            </div>

                                            <div class="progress-bar">
                                                <label>Sports Injury <span>95%</span></label>
                                                <div class="progress">
                                                    <div class="progress-inner" style={{ width: '95%' }}></div>
                                                </div>
                                            </div>
                                            <div class="progress-bar" >
                                                <label>Stroke & Neurological <span>87%</span></label>
                                                <div class="progress">
                                                    <div class="progress-inner" style={{ width: '87%' }}></div>
                                                </div>
                                            </div>

                                            <div class="progress-bar" style={{ margin: 0 }}>
                                                <label>Physiotherapy services<span>96%</span></label>
                                                <div class="progress">
                                                    <div class="progress-inner" style={{ width: '96%' }}></div>
                                                </div>
                                            </div>

                                        </div>
                                        <div class="space32"></div>
                                        {/* <div class="btn-area1">
                                            <a href="contact.html" class="vl-btn4">Schedule An Appointment <span><svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22" fill="none">
                                                <path fill-rule="evenodd" clip-rule="evenodd" d="M11 0.25C5.06294 0.25 0.25 5.06294 0.25 11C0.25 16.9371 5.06294 21.75 11 21.75C16.9371 21.75 21.75 16.9371 21.75 11C21.75 5.06294 16.9371 0.25 11 0.25ZM10 7C9.5955 7 9.2309 7.24364 9.0761 7.61732C8.92134 7.99099 9.0069 8.42111 9.2929 8.70711L10.5858 10L7.29289 13.2929C6.90237 13.6834 6.90237 14.3166 7.29289 14.7071C7.68342 15.0976 8.31658 15.0976 8.70711 14.7071L12 11.4142L13.2929 12.7071C13.5789 12.9931 14.009 13.0787 14.3827 12.9239C14.7564 12.7691 15 12.4045 15 12V8C15 7.44772 14.5523 7 14 7H10Z" fill="white" />
                                            </svg></span></a>
                                        </div> */}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>


                    <div class="slider4-section-area">
                        <div class="marquee-wrap">
                            <div class="marquee-text">
                                <div class="brand-single-box">
                                    <h3><img src="assets/img/elements/elements1.html" alt="" /> Personalized Care</h3>
                                </div>

                                <div class="brand-single-box">
                                    <h3><img src="assets/img/elements/elements1.html" alt="" /> Experienced Professionals</h3>
                                </div>

                                <div class="brand-single-box">
                                    <h3><img src="assets/img/elements/elements1.html" alt="" /> Advanced Technology</h3>
                                </div>

                                <div class="brand-single-box">
                                    <h3><img src="assets/img/elements/elements1.html" alt="" /> Preventive Care</h3>
                                </div>

                                <div class="brand-single-box">
                                    <h3><img src="assets/img/elements/elements1.html" alt="" /> Patient-Centered Approach</h3>
                                </div>

                                <div class="brand-single-box">
                                    <h3><img src="assets/img/elements/elements1.html" alt="" /> Personalized Care</h3>
                                </div>

                                <div class="brand-single-box">
                                    <h3><img src="assets/img/elements/elements1.html" alt="" /> Experienced Professionals</h3>
                                </div>

                                <div class="brand-single-box">
                                    <h3> <img src="assets/img/elements/elements1.html" alt="" />Advanced Technology</h3>
                                </div>

                                <div class="brand-single-box">
                                    <h3><img src="assets/img/elements/elements1.html" alt="" /> Preventive Care</h3>
                                </div>

                                <div class="brand-single-box">
                                    <h3><img src="assets/img/elements/elements1.html" alt="" /> Patient-Centered Approach</h3>
                                </div>
                                <div class="brand-single-box">
                                    <h3><img src="assets/img/elements/elements1.html" alt="" /> Personalized Care</h3>
                                </div>

                                <div class="brand-single-box">
                                    <h3><img src="assets/img/elements/elements1.html" alt="" /> Experienced Professionals</h3>
                                </div>

                                <div class="brand-single-box">
                                    <h3><img src="assets/img/elements/elements1.html" alt="" /> Advanced Technology</h3>
                                </div>

                                <div class="brand-single-box">
                                    <h3><img src="assets/img/elements/elements1.html" alt="" /> Preventive Care</h3>
                                </div>

                                <div class="brand-single-box">
                                    <h3><img src="assets/img/elements/elements1.html" alt="" /> Patient-Centered Approach</h3>
                                </div>
                            </div>
                        </div>
                    </div>


                    <div class="about4-section-area sp1">
                        <div class="container">
                            <div class="row align-items-center">
                                <div class="col-lg-6">
                                    <div class="about-images-area">
                                        <div class="img1 image-anime">
                                            {/* <div class="img1 image-anime reveal"> */}

                                            <img src="assets/img/all-images/about/docabout.png" alt="" />
                                        </div>
                                        <div class="img2">
                                            <img src="assets/img/elements/elements18.png" alt="" class="elements18 keyframe5" />
                                        </div>
                                    </div>
                                </div>
                                <div class="col-lg-6">
                                    <div class="about4-heading heading4">
                                        <h5 class="vl-section-subtitle" data-aos-duration="800">Ntinda Medical Rehabilitation Center<span> | </span> About Us <svg xmlns="http://www.w3.org/2000/svg" width="13" height="8" viewBox="0 0 13 8" fill="none">
                                            <path d="M0.667969 4.00033H11.049M8.00137 7.33366L11.3346 4.00033L8.0013 0.666992" stroke="#02015A" stroke-width="1.5" />
                                        </svg>
                                        </h5>
                                        <div class="space24"></div>
                                        <h2 class="vl-section-title text-anime-style-3">Your health and happiness are our top priorities. </h2>
                                        <div class="space24"></div>
                                        <p data-aos-duration="900">At Ntinda Medical and Rehabilitation Center, we go beyond just treating symptoms – we focus on addressing the underlying causes of illness and promoting holistic well-being. Whether you're seeking preventive care, managing a chronic condition, or in need of specialized treatment, you can trust that you're in good hands with
                                            our team.</p>
                                        <div class="row">
                                            <div class="col-lg-6">
                                                <div class="counter-boxarea" data-aos-duration="1000">
                                                    <h2><span class="counter">500</span>+</h2>
                                                    <div class="space16"></div>
                                                    <p>Serving patients weekly</p>
                                                </div>
                                            </div>

                                            <div class="col-lg-6">
                                                <div class="counter-boxarea" data-aos-duration="1100">
                                                    <h2><span class="counter">95</span>%</h2>
                                                    <div class="space16"></div>
                                                    <p>Patient satisfaction rate</p>
                                                </div>
                                            </div>

                                            <div class="col-lg-6">
                                                <div class="counter-boxarea" data-aos-duration="1200">
                                                    <h2><span class="counter">10</span>+</h2>
                                                    <div class="space16"></div>
                                                    <p>Years serving the community</p>
                                                </div>
                                            </div>

                                            <div class="col-lg-6">
                                                <div class="counter-boxarea" data-aos-duration="1000">
                                                    <h2><span class="counter">24</span>/7</h2>
                                                    <div class="space16"></div>
                                                    <p>Urgent care available</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>


                    <div class="team4-section-area sp1">
                        <div class="container">
                            <div class="row">
                                <div class="col-lg-5 m-auto">
                                    <div class="heading4 text-center space-margin60">
                                        <h5 class="vl-section-subtitle">Ntinda Medical Rehab Center<span> | </span>Our Team <svg xmlns="http://www.w3.org/2000/svg" width="13" height="8" viewBox="0 0 13 8" fill="none">
                                            <path d="M0.667969 4.00033H11.049M8.00137 7.33366L11.3346 4.00033L8.0013 0.666992" stroke="#02015A" stroke-width="1.5" />
                                        </svg>
                                        </h5>
                                        <div class="space24"></div>
                                        <h2 class="vl-section-title text-anime-style-3">Meet Our Expert Medical Team</h2>
                                    </div>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-lg-12">

                                    {<Sliders />}
                                </div>
                                {/* <div class="col-lg-12">
                                    <div class="space30"></div>
                                    <div class="btn-area1 text-center">
                                        <a href="doctor.html" class="vl-btn4">Join Our Team <span><svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22" fill="none">
                                            <path fill-rule="evenodd" clip-rule="evenodd" d="M11 0.25C5.06294 0.25 0.25 5.06294 0.25 11C0.25 16.9371 5.06294 21.75 11 21.75C16.9371 21.75 21.75 16.9371 21.75 11C21.75 5.06294 16.9371 0.25 11 0.25ZM10 7C9.5955 7 9.2309 7.24364 9.0761 7.61732C8.92134 7.99099 9.0069 8.42111 9.2929 8.70711L10.5858 10L7.29289 13.2929C6.90237 13.6834 6.90237 14.3166 7.29289 14.7071C7.68342 15.0976 8.31658 15.0976 8.70711 14.7071L12 11.4142L13.2929 12.7071C13.5789 12.9931 14.009 13.0787 14.3827 12.9239C14.7564 12.7691 15 12.4045 15 12V8C15 7.44772 14.5523 7 14 7H10Z" fill="white" />
                                        </svg></span>
                                        </a>
                                    </div>
                                </div> */}
                            </div>
                        </div>
                    </div>


                    <div class="works4-section-area sp6">
                        <div class="container">
                            <div class="row">
                                <div class="col-lg-8 m-auto">
                                    <div class="heading4 text-center space-margin60">
                                        <h5 class="vl-section-subtitle">Ntinda Medical Rehab Center<span> | </span> How it works <svg xmlns="http://www.w3.org/2000/svg" width="13" height="8" viewBox="0 0 13 8" fill="none">
                                            <path d="M0.667969 4.00033H11.049M8.00137 7.33366L11.3346 4.00033L8.0013 0.666992" stroke="#02015A" stroke-width="1.5" />
                                        </svg>
                                        </h5>
                                        <div class="space24"></div>
                                        <h2 class="vl-section-title text-anime-style-3">How Ntinda Medical Rehab Center Works</h2>
                                    </div>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-lg-12" data-aos-duration="1200">
                                    <div class="cs_case_study_1_list">
                                        <div class="cs_case_study cs_style_1 cs_hover_active active" data-aos-duration="800">
                                            <a href="case-single.html" class="cs_case_study_thumb cs_bg_filed" data-src="assets/img/all-images/works/work-img10.png"></a>
                                            <div class="content-area1">
                                                <div class="arrow">
                                                    <a href="#">1</a>
                                                </div>
                                                <div class="text">
                                                    <a href="case-single.html">Schedule An Appointment</a>
                                                </div>
                                            </div>
                                            <div class="content-area">
                                                <div class="arrow2">
                                                    <a href="#">1</a>
                                                </div>
                                                <div class="space32"></div>
                                                <a href="case-single.html" class="head">Schedule An Appointment</a>
                                                <div class="space16"></div>
                                                <p>Begin your journey to better health by scheduling a consultation with Ntinda Medical And Rehabilitation Center. You can easily book your appointment by through whatsapp, mail or our friendly reception team. We offer flexible appointment times to accommodate your schedule, including evening and appointments for your convenience.</p>
                                                <div class="space30"></div>
                                                <div class="img1">
                                                    <img src="assets/img/all-images/works/work-img10.png" alt="" />
                                                </div>
                                            </div>
                                        </div>
                                        <div class="cs_case_study cs_style_1 box2 cs_hover_active" data-aos-duration="900">
                                            <a href="case-single.html" class="cs_case_study_thumb cs_case_study_thumb2 cs_bg_filed" data-src="assets/img/all-images/case/case-img2.html"></a>
                                            <div class="content-area1">
                                                <div class="arrow">
                                                    <a href="#">2</a>
                                                </div>
                                                <div class="text">
                                                    <a href="case-single.html">Consultation</a>
                                                </div>
                                            </div>
                                            <div class="content-area">
                                                <div class="arrow2">
                                                    <a href="#">2</a>
                                                </div>
                                                <div class="space32"></div>
                                                <a href="case-single.html" class="head">Consultation</a>
                                                <div class="space16"></div>
                                                <p>
                                                    Ntinda Medical and Rehabilitation Center consultations begin with reviewing your medical history and symptoms, followed by a physical examination. Diagnostic tests may be conducted, and a personalized treatment plan—ranging from therapy to surgery—is provided, along with guidance on follow-up care and rehabilitation for optimal musculoskeletal recovery.
                                                </p>
                                                <div class="space30"></div>
                                                <div class="img1">
                                                    <img src="assets/img/all-images/works/work-img10.png" alt="" />
                                                </div>
                                            </div>
                                        </div>
                                        <div class="cs_case_study cs_style_1 box3 cs_hover_active" data-aos-duration="1000">
                                            <a href="case-single.html" class="cs_case_study_thumb cs_case_study_thumb3 cs_bg_filed" data-src="assets/img/all-images/case/case-img3.html"></a>
                                            <div class="content-area1">
                                                <div class="arrow">
                                                    <a href="#">3</a>
                                                </div>
                                                <div class="text">
                                                    <a href="case-single.html">Personalized Treatment</a>
                                                </div>
                                            </div>
                                            <div class="content-area">
                                                <div class="arrow2">
                                                    <a href="#">3</a>
                                                </div>
                                                <div class="space32"></div>
                                                <a href="case-single.html" class="head">Personalized Treatment</a>
                                                <div class="space16"></div>
                                                <p>
                                                    A personalized orthopedic treatment at Ntinda Medical and Rehabilitation Center is tailored to each patient’s condition and needs. It may include medication, physical therapy, minimally invasive procedures, or surgery. The plan focuses on relieving pain, restoring mobility, and improving joint function, with ongoing guidance for rehabilitation and long-term musculoskeletal health.
                                                </p>
                                                <div class="space30"></div>
                                                <div class="img1">
                                                    <img src="assets/img/all-images/works/work-img10.png" alt="" />
                                                </div>
                                            </div>
                                        </div>
                                        <div class="cs_case_study cs_style_1 box4 cs_hover_active" data-aos-duration="1100">
                                            <a href="case-single.html" class="cs_case_study_thumb cs_case_study_thumb4 cs_bg_filed" data-src="assets/img/all-images/case/case-img4.html"></a>
                                            <div class="content-area1">
                                                <div class="arrow">
                                                    <a href="#">4</a>
                                                </div>
                                                <div class="text">
                                                    <a href="case-single.html">Ongoing Care</a>
                                                </div>
                                            </div>
                                            <div class="content-area">
                                                <div class="arrow2">
                                                    <a href="#">4</a>
                                                </div>
                                                <div class="space32"></div>
                                                <a href="case-single.html" class="head">Ongoing Care</a>
                                                <div class="space16"></div>
                                                <p>
                                                    Ongoing orthopedic treatment at Ntinda Medical and Rehabilitation Center involves continuous care to manage musculoskeletal conditions. It includes regular monitoring, physical therapy, medication adjustments, and follow-up assessments. The approach ensures pain relief, improved mobility, and gradual recovery, supporting patients in maintaining joint function and achieving long-term musculoskeletal health.
                                                </p>
                                                <div class="space30"></div>
                                                <div class="img1">
                                                    <img src="assets/img/all-images/works/work-img10.png" alt="" />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>


                    <div class="testimonial4-section-area sp1" style={{ backgroundImage: `url(assets/img/all-images/bg/bg6.png)`, backgroundPosition: 'center top', backgroundRepeat: 'no-repeat', backgroundSize: 'cover' }}>
                        {/* style="background-image: url(assets/img/all-images/bg/bg6.png); background-position: center; background-repeat: no-repeat; background-size: cover;" */}
                        <img src="assets/img/elements/elements12.png" alt="" class="elements12 keyframe5" />
                        <div class="container">
                            <div class="row">
                                <div class="col-lg-8 m-auto">
                                    <div class="heading4 text-center space-margin60">
                                        <div class="heading4 text-center space-margin60">
                                            <h5 class="vl-section-subtitle">Ntinda Medical Rehab Center<span> | </span>Testimonials <svg xmlns="http://www.w3.org/2000/svg" width="13" height="8" viewBox="0 0 13 8" fill="none">
                                                <path d="M0.667969 4.00033H11.049M8.00137 7.33366L11.3346 4.00033L8.0013 0.666992" stroke="#02015A" stroke-width="1.5" />
                                            </svg>
                                            </h5>
                                            <div class="space24"></div>
                                            <h2 class="vl-section-title text-anime-style-3">Our clients always love us</h2>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="row">

                                <div class="col-lg-12">
                                    {/* <ReactGoogleReviews layout="carousel" featurableId={featurableWidgetId} /> */}
                                    {/* <div id="featurable-879ee8d6-bd09-47c1-8a55-5ba9eba77ae0" data-featurable-async ></div> */}

                                    <iframe src="https://featurable.com/widgets/v2/879ee8d6-bd09-47c1-8a55-5ba9eba77ae0" style={{ width: '100%', height: '500px', border: '0', allowfullscreen: '', loading: 'lazy' }} ></iframe>


                                </div>
                                <div class="col-lg-12">
                                    <div class="space40"></div>
                                    <div class="btn-area1 text-center">
                                        <a href="https://wa.me/256755260852" class="vl-btn4">Schedule an Appointment <span><svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22" fill="none">
                                            <path fill-rule="evenodd" clip-rule="evenodd" d="M11 0.25C5.06294 0.25 0.25 5.06294 0.25 11C0.25 16.9371 5.06294 21.75 11 21.75C16.9371 21.75 21.75 16.9371 21.75 11C21.75 5.06294 16.9371 0.25 11 0.25ZM10 7C9.5955 7 9.2309 7.24364 9.0761 7.61732C8.92134 7.99099 9.0069 8.42111 9.2929 8.70711L10.5858 10L7.29289 13.2929C6.90237 13.6834 6.90237 14.3166 7.29289 14.7071C7.68342 15.0976 8.31658 15.0976 8.70711 14.7071L12 11.4142L13.2929 12.7071C13.5789 12.9931 14.009 13.0787 14.3827 12.9239C14.7564 12.7691 15 12.4045 15 12V8C15 7.44772 14.5523 7 14 7H10Z" fill="white" />
                                        </svg></span>
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>


                    <div class="slider4-section-area">
                        <div class="marquee-wrap">
                            <div class="marquee-text">
                                <div class="brand-single-box">
                                    <h3><img src="assets/img/elements/elements1.html" alt="" /> Personalized Care</h3>
                                </div>

                                <div class="brand-single-box">
                                    <h3><img src="assets/img/elements/elements1.html" alt="" /> Experienced Professionals</h3>
                                </div>

                                <div class="brand-single-box">
                                    <h3><img src="assets/img/elements/elements1.html" alt="" /> Advanced Technology</h3>
                                </div>

                                <div class="brand-single-box">
                                    <h3><img src="assets/img/elements/elements1.html" alt="" /> Preventive Care</h3>
                                </div>

                                <div class="brand-single-box">
                                    <h3><img src="assets/img/elements/elements1.html" alt="" /> Patient-Centered Approach</h3>
                                </div>

                                <div class="brand-single-box">
                                    <h3><img src="assets/img/elements/elements1.html" alt="" /> Personalized Care</h3>
                                </div>

                                <div class="brand-single-box">
                                    <h3><img src="assets/img/elements/elements1.html" alt="" /> Experienced Professionals</h3>
                                </div>

                                <div class="brand-single-box">
                                    <h3> <img src="assets/img/elements/elements1.html" alt="" />Advanced Technology</h3>
                                </div>

                                <div class="brand-single-box">
                                    <h3><img src="assets/img/elements/elements1.html" alt="" /> Preventive Care</h3>
                                </div>

                                <div class="brand-single-box">
                                    <h3><img src="assets/img/elements/elements1.html" alt="" /> Patient-Centered Approach</h3>
                                </div>
                                <div class="brand-single-box">
                                    <h3><img src="assets/img/elements/elements1.html" alt="" /> Personalized Care</h3>
                                </div>

                                <div class="brand-single-box">
                                    <h3><img src="assets/img/elements/elements1.html" alt="" /> Experienced Professionals</h3>
                                </div>

                                <div class="brand-single-box">
                                    <h3><img src="assets/img/elements/elements1.html" alt="" /> Advanced Technology</h3>
                                </div>

                                <div class="brand-single-box">
                                    <h3><img src="assets/img/elements/elements1.html" alt="" /> Preventive Care</h3>
                                </div>

                                <div class="brand-single-box">
                                    <h3><img src="assets/img/elements/elements1.html" alt="" /> Patient-Centered Approach</h3>
                                </div>
                            </div>
                        </div>
                    </div>


                    {<Footer />}
                </body>
            </>
        )
    }
}
export default AboutUs


//  <div>
//                         <div class="vl-main-menu text-center" style={{
//                             display: open ? "block" : "none",
//                             position: "fixed",
//                             // opacity:0.8,
//                             top: "12px",
//                             right: "65px",
//                             background: "#070808ff",
//                             // padding: "16px",
//                             border: "1px solid #02332fff",
//                             zIndex: 9999
//                         }}>
//                             <nav>
//                                 <ul>
//                                     <li style={{fontSize:'5px'}}>
//                                         <Link to="/">Home   </Link>
//                                     </li>
//                                     <li>
//                                         <Link to="/about-us">About Us</Link>
//                                         {/* <a href="about.html">Who We Are   </a> */}

//                                     </li>
//                                     <li>
//                                         <Link to="/our-services">Services</Link>
//                                         {/* <a href="service.html">Services   </a> */}
//                                     </li>

//                                     <li><Link to="/gallery">Gallery   </Link></li>
//                                 </ul>
//                             </nav>
//                         </div>
//                     </div>